import { TotalCard } from "./total-card-data";
import { FeesChart } from "./fees-chart-data";
import { PaymentStatus } from "./payment-status-chart-data";
import { LoanModel } from "providers/loans/loan.model";
import { LoanHelper } from "providers/loans/helpers/loan.helpers";
import { LienType, LienTypeData } from "./lien-type";
import { XeroAccount } from "hooks/xero-accounts/xero-account.model";

export interface IRevenue {
	totals: TotalCard[];
	fees: FeesChart;
	paymentStatus: PaymentStatus;
}

export class Revenue implements IRevenue {
	private readonly LOAN_LIEN_TYPE_KEY = "loan lien type";

	totals: TotalCard[] = [
		{
			title: "Total Invested Amount",
			value: 0,
		},
		{
			title: "Total Fee Amount",
			value: 0,
		},
	];

	fees: FeesChart = {
		lienTypes: [],
	};
	paymentStatus: PaymentStatus = {
		data: [],
	};

	constructor(loans: LoanModel[], accounts: XeroAccount[]) {
		const grouped = LoanHelper.groupByFieldLabel(
			loans,
			this.LOAN_LIEN_TYPE_KEY
		);

		this.fillFees(grouped, accounts);
		this.fillPaymentStatus(grouped);
	}

	private fillFees(
		grouped: Map<string, LoanModel[]>,
		accounts: XeroAccount[]
	): void {
		grouped.forEach((loans, key) => {
			const lienType: LienType = {
				title: key,
				data: [],
			};
			accounts.forEach((account) => {
				const lienTypeData: LienTypeData = {
					name: account.description,
					value: 0,
				};

				loans.forEach((loan) => {
					loan.fees
						.filter((fee) => {
							return fee.account === account.code;
						})
						.forEach((fee) => {
							lienTypeData.value += fee.fee_amount ?? 0;
							this.totals[1].value += fee.fee_amount ?? 0;
						});
				});

				lienType.data.push(lienTypeData);
			});

			this.fees.lienTypes.push(lienType);
		});
	}

	private fillPaymentStatus(grouped: Map<string, LoanModel[]>): void {
		grouped.forEach((loans, key) => {
			const paymentStatus = {
				title: key,
				unpaid: 0,
				pending: 0,
				paid: 0,
				approved: 0,
				declined: 0,
			} as any;

			loans.forEach((loan) => {
				loan.accounts_receivable.forEach((accountReceivable) => {
					if (accountReceivable.payment_status) {
						paymentStatus[accountReceivable.payment_status] += 1;
						this.totals[0].value += accountReceivable.payment_amount ?? 0;
					}
				});
			});

			this.paymentStatus.data.push(paymentStatus);
		});
	}
}
